import naja from 'naja';
import '../../common/scss/components/modal.scss';

let previousUrl = window.location.href;
let previousTitle = document.title;
let bodyScrollTop = 0;

naja.addEventListener('before', () => {
    previousUrl = window.location.href;
    previousTitle = document.title;
});

naja.addEventListener('success', event => {
    if (event.detail.payload?.showModal) {
        showModal();
    }
});

document.addEventListener('click', event => {
    if (event.target.closest('.modal .close') || event.target.matches('.modal.open')) {
        hideModal();
        return;
    }

    const closeOverlay = event.target.closest('.job-sidebar .closeOverlay');
    if (closeOverlay) {
        event.preventDefault();
        document.querySelector('.job-sidebar .reacted')?.remove();
        return;
    }

    const phone = event.target.closest('.contact-phone[data-conversion-url]');
    if (phone?.dataset.conversionUrl) {
        void naja.makeRequest('GET', phone.dataset.conversionUrl, null, {
            history: false,
            noLoader: true,
        });
    }
});

document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && document.querySelector('.modal.open')) {
        hideModal();
    }
});

window.addEventListener('popstate', event => {
    const state = event.state;
    if (state?.url) {
        document.title = state.title || getDefaultTitle();
        void naja.makeRequest('GET', state.url, null, {history: false});
    } else {
        void naja.makeRequest('GET', window.location.origin, null, {history: false});
        document.querySelector('.modal')?.remove();
    }
    enableBodyScroll();
});

function showModal() {
    document.querySelector('.modal')?.classList.add('open');
    disableBodyScroll();
}

function hideModal() {
    const modal = document.querySelector('.modal');
    if (!modal?.classList.contains('open')) {
        return;
    }

    enableBodyScroll();
    modal.classList.remove('open');
    modal.classList.add('close');

    const title = previousTitle || getDefaultTitle();
    history.pushState({url: previousUrl, title}, title, previousUrl);
    document.title = title;

    const dialog = modal.querySelector('.modal-dialog');
    if (dialog) {
        dialog.addEventListener('animationend', () => modal.classList.remove('close'), {once: true});
    } else {
        modal.classList.remove('close');
    }
}

function getDefaultTitle() {
    return document.querySelector('title')?.dataset.default || document.title;
}

function disableBodyScroll() {
    bodyScrollTop = window.scrollY;
    document.documentElement.classList.add('disable-scroll');
    document.body.classList.add('disable-scroll');

    if (supportsTouch()) {
        document.body.style.position = 'relative';
        document.body.style.top = `-${bodyScrollTop}px`;
        document.body.style.height = `${window.innerHeight + bodyScrollTop}px`;
    }
}

function enableBodyScroll() {
    document.documentElement.classList.remove('disable-scroll');
    document.body.classList.remove('disable-scroll');

    if (supportsTouch() && document.body.style.top) {
        document.body.removeAttribute('style');
        window.setTimeout(() => window.scrollTo(0, bodyScrollTop), 50);
    }
}

function supportsTouch() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
